<div class="page">
  <app-page-header 
    itemName="" 
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
  >
  </app-page-header>
  <div class="page-content">
    <!-- Nav -->
    <div class="row mb-4">
      <div class="col-12">

        <button *ngIf="!mappaturaOpen || (mappaturaOpen && (subscriptionType ==='FREE' || subscriptionType ==='FREEBASIC'))" class="navigation-button" mat-flat-button routerLinkActive="navigation-button-active"
          routerLink="/{{ lang}}/app/properties/{{propertyId}}/documents">
          {{ 'properties.list.goToDocuments' | translate }}
        </button>

        <button *ngIf="mappaturaOpen && subscriptionType !=='FREE' && subscriptionType !=='FREEBASIC'" class="navigation-button" mat-flat-button (click)="onGoToDocumentArchive()">
          {{ 'properties.list.goToDocuments' | translate }}
        </button>

        <button class="navigation-button" mat-flat-button routerLinkActive="navigation-button-active"
          routerLink="/{{ lang}}/app/properties/{{propertyId}}/mapping" *ngIf="!masterAndSubscriptionPrivacy && subscriptionType !=='FREE' && subscriptionType !=='FREEBASIC'">
          {{ 'properties.list.goToMapping' | translate }}
        </button>

        <button class="navigation-button" mat-flat-button routerLinkActive="navigation-button-active"
          *ngIf="loggedUserRoleType !== 'temporary' && loggedUserRoleType !== 'shared' && loggedUserPermissions.includes('canSearchDocuments')"
          routerLink="/{{ lang}}/app/properties/{{propertyId}}/search">
          {{ 'properties.list.searchDocuments' | translate }}
        </button>

        <button class="navigation-button" mat-flat-button routerLinkActive="navigation-button-active"
          routerLink="/{{ lang}}/app/properties/{{propertyId}}/addNewDocuments">
          {{ 'properties.documentsPage.insertDocs' | translate }}
        </button>

        <button class="navigation-button" mat-flat-button [matMenuTriggerFor]="exportMenu" color="primary">
          {{ 'common.export' | translate }}
          <mat-icon class="ml-2" fontSet="fas" fontIcon="fa-caret-down"></mat-icon>
        </button>
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item *ngIf="loggedUserPermissions.includes('canExportProperties')"
            (click)="onExport('insertedDocs2025', propertyId)" color="primary">
            <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
            {{ 'properties.list.exportExpiredDocuments' | translate }}
          </button>

          <button mat-menu-item *ngIf="loggedUserPermissions.includes('canExportProperties') && subscriptionType !=='FREE' && subscriptionType !=='FREEBASIC'"
            (click)="onExport('missingDocs', propertyId)" color="primary">
            <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
            {{ 'properties.list.exportMissingDocuments' | translate }}
          </button>

          <button mat-menu-item *ngIf="subscriptionType !=='FREE' && subscriptionType !=='FREEBASIC'"
            (click)="onExportRAS()" color="primary">
            <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
            {{ 'properties.list.exportRas' | translate }}
          </button>

          <button mat-menu-item *ngIf="loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator'"
            (click)="onExportContracts()" color="primary">
            <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
            {{ 'properties.list.exportContracts' | translate }}
          </button>
        </mat-menu>
      </div>
    </div>
    <!-- end Nav -->

    <div class="alert alert-danger text-center my-4" *ngIf="propertyData && !propertyData.active">
      {{ 'properties.detail.suspended_property_alert' | translate }}
    </div>

    <mat-card class="custom-card mt-4">
      <app-card-spinner [visible]="documentArchiveIsLoading" type="zero"></app-card-spinner>
      <div class="row">
        <div class="col-12">
          <mat-card-title>{{ 'properties.addDocumentsPage.documentsTab.title' | translate }}
          </mat-card-title>
          <mat-card-subtitle class="mb-0">{{ property.get('name') }}</mat-card-subtitle>
        </div>
      </div>
      <mat-card-content>
        <!-- Select doc type: digital or paper -->
        <ng-container class="digital-document-wrapper" *ngIf="!docType && !docUploaded">
          <div class="row p-5">
            <div class="col-12">
              <div class="row">
                <div class="col-12 text-center mb-4">
                  {{ 'properties.addDocumentsPage.docTypes.chooseMessage' | translate }}
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <button class="mr-2 mb-2" mat-stroked-button (click)="onChooseDocType('mockup')" color="warn">
                    {{ 'properties.addDocumentsPage.docTypes.mockup' | translate }}
                    <mat-icon fontSet="fal" fontIcon="fa-star"></mat-icon>
                  </button>
                  <button class="mr-2 mb-2" mat-stroked-button (click)="onChooseDocType('digital')" color="primary">
                    {{ 'properties.addDocumentsPage.docTypes.digital' | translate }}
                    <mat-icon fontSet="fal" fontIcon="fa-desktop"></mat-icon>
                  </button>
                  <button mat-stroked-button (click)="onChooseDocType('paper')" color="accent">
                    {{ 'properties.addDocumentsPage.docTypes.paper' | translate }}
                    <mat-icon fontSet="fal" fontIcon="fa-scroll"></mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- /Select doc type: digital or paper -->

        <!-- Select docs from list and input data -->
        <ng-container *ngIf="docType">
          <div *ngIf="!editDocument"><strong>{{ 'properties.addDocumentsPage.structureOpend' | translate }}</strong>
          </div>

          <!-- STEP 0: select docs -->
          <div class="row" *ngIf="editDocument && step0">
            <div class="col-12 col-md-5 col-lg-4">
              
              <!-- sub title doc type and Btn to change doc type  -->
              <div class="doc-type-wrapper" *ngIf="loggedUserAdmin">
                <strong>{{ 'properties.addDocumentsPage.docTypes.label' | translate }}:</strong>
                <span class="ml-2">
                  {{ 'properties.addDocumentsPage.docTypes.' + docType | translate }}
                </span>
                <button class="ml-2" mat-icon-button (click)="docType = undefined" color="primary"
                  matTooltip="{{ 'common.cta.change' | translate }}">
                  <mat-icon fontSet="fas" fontIcon="fa-exchange"></mat-icon>
                </button>
              </div>
              <!-- /sub title doc type and Btn to change doc type  -->
              
              <!-- Side menu -->
              <div class="side-menu">
                
                <!-- Area -->
                <ng-container>
                  <p class="mb-2"><strong>{{ 'properties.addDocumentsPage.area.title' | translate }}</strong></p>
                  <mat-radio-group name="radioArea" [(ngModel)]="selectedArea" (change)="onChangeArea($event)">
                    <div class="text-wrapper">
                      <mat-radio-button class="mb-1" [value]="1">
                        {{ 'properties.addDocumentsPage.area.gestionale' | translate }}</mat-radio-button>
                    </div>
                    <div class="text-wrapper">
                      <mat-radio-button class="mb-1" [value]="2">
                        {{ 'properties.addDocumentsPage.area.contratti' | translate }}</mat-radio-button>
                    </div>
                    <div class="text-wrapper">
                      <mat-radio-button class="mb-1" [value]="3">
                        {{ 'properties.addDocumentsPage.area.tecnica' | translate }}</mat-radio-button>
                    </div>
                    <div class="text-wrapper">
                      <mat-radio-button class="mb-1" [value]="4" *ngIf="unitaImmobiliari">
                        {{ 'properties.addDocumentsPage.area.unitaImmobiliari' | translate }}</mat-radio-button>
                    </div>
                  </mat-radio-group>
                </ng-container>
                <!-- /Area -->

                <!-- Arguments -->
                <ng-container *ngIf="docArea?.content">
                  <p class="mb-2"><strong>{{ 'properties.addDocumentsPage.topics.title' | translate }}</strong></p>
                  <ng-container *ngFor="let item of docArea?.content;">
                    <!-- 1 level -->
                    <div class="text-wrapper" *ngIf="item.visible">
                      <mat-checkbox [(ngModel)]="item.value" [disabled]="item.disabled" class="checkbox-insert"
                        (change)="onChangeTopic(item.code, $event.checked)">
                        <span *ngIf="lang === 'it'">{{ item.translation.it }}</span>
                        <span *ngIf="lang !== 'it'">{{ item.translation.en }}</span>
                      </mat-checkbox>
                    </div>
                    <!-- /1 level -->
                    <!-- 2 level -->
                    <div *ngIf="docTopics">
                      <ng-container *ngFor="let subItem of docTopics">
                        <div class="text-wrapper ml-3" *ngIf="subItem.visible && subItem.parent === item.code">
                          <mat-checkbox [(ngModel)]="subItem.value" [disabled]="subItem.disabled"
                            (change)="onChangeSubTopic(subItem, $event.checked, item.code)" class="checkbox-insert">
                            <span *ngIf="lang === 'it'">{{ subItem.translation.it }}</span>
                            <span *ngIf="lang !== 'it'">{{ subItem.translation.en }}</span>
                          </mat-checkbox>
                        </div>
                      </ng-container>
                    </div>
                    <!-- /2 level -->
                  </ng-container>
                </ng-container>
                <!-- /Arguments -->

                
              </div>
              <!-- /Side menu -->
            </div>

            <!-- List of all documents -->
            <div class="col-12 col-md-7 col-lg-8">
              <div class="row side-heading-wrapper">
                <div class="col-6">
                  <mat-form-field *ngIf="docSubTopics">
                    <mat-label>Cerca il documento</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Cerca..."
                      [disabled]="!docSubTopics.length" [value]="searchValue">
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <button class="navigation-button" mat-stroked-button [disabled]="!checkboxesAreSelected"
                    (click)="onStep1()" color="primary">
                    {{ 'properties.addDocumentsPage.bnt.step1' | translate }}
                    <mat-icon fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
                  </button>
                </div>
              </div>

              <div>
                <ng-container *ngFor="let parentTitle of selectedSubTopics">
                  <div class="text-wrapper my-2" *ngIf="parentTitle.visible && parentTitle.value">
                    <strong *ngIf="lang === 'it'">{{ parentTitle.translation.it }}</strong>
                    <strong *ngIf="lang !== 'it'">{{ parentTitle.translation.en }}</strong>
                  </div>
                  <div *ngIf="parentTitle">
                    <ng-container *ngFor="let item of docSubTopics">
                      <div class="text-wrapper" *ngIf="item.visible && item.parent === parentTitle.code">
                        <mat-checkbox [(ngModel)]="item.value"
                          [disabled]="checkboxesAreSelected && acceptedType && acceptedType !== item.schemaType"
                          (change)="onSetSubDoc(item.code, $event.checked)" class="checkbox-insert">
                          {{ item.title | translate }}
                        </mat-checkbox>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
            <!-- /List of all documents -->
          </div>
          <!-- /STEP 0: select docs -->

          <!-- STEP 1: input data of selected docs -->
          <div class="row" *ngIf="editDocument && step1">
            <div class="col-12 mb-3">
              <button class="navigation-button" mat-stroked-button (click)="onStep0()" color="primary"
                *ngIf="!docUploaded">
                <mat-icon fontSet="fal" fontIcon="fa-chevron-left"></mat-icon>
                {{ 'common.cta.back' | translate }}
              </button>
              <button class="navigation-button" mat-flat-button (click)="onRestart()" color="primary"
                *ngIf="docUploaded">
                <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
                {{ 'properties.addDocumentsPage.insertNew' | translate }}
              </button>
              <mat-spinner-button *ngIf="docUploaded" (btnClick)="onPrint('module')" [options]="printModuleBtnOptions"
                class="btn-elevate">
              </mat-spinner-button>
              <mat-spinner-button *ngIf="docUploaded" (btnClick)="onPrint('qr')" [options]="printQrBtnOptions"
                class="btn-elevate ml-2">
              </mat-spinner-button>
            </div>
            <div class="col-12 col-lg-5">
              <!-- Side menu -->
              <div class="side-menu">
                <h5>{{ 'properties.addDocumentsPage.docsSelected' | translate }}</h5>
                <div class="alert alert-warning my-3" role="alert" *ngIf="!canSubmitForm">
                  {{ 'properties.addDocumentsPage.selectAtLeastOne' | translate }}
                  {{ 'properties.addDocumentsPage.element_from_bottom' | translate }}
                </div>
                <div class="selected-document-wrapper" *ngFor="let item of docsSelected; let i = index">

                  <div class="mt-1" style="clear: both" *ngIf="docsSelected[i+1] && item.subDoc === docsSelected[i+1].subDoc">
                    <div>{{ item.title }}</div>
                  </div>

                  <!-- If this is last element of group, let's show checkboxes under it -->
                  <div class="mb-3"
                    *ngIf="!docsSelected[i+1] || (docsSelected[i+1] && item.subDoc !== docsSelected[i+1].subDoc)">
                    <div>{{ item.title }}</div>
                    <div class="font-italic" *ngIf="subscriptionType !=='FREE' && subscriptionType !=='FREEBASIC' && item.structureSelected && item.structureSelected.length">
                      <div *ngIf="item.subDoc !=='gestAmmTivoDipendenti'">
                        {{ 'properties.addDocumentsPage.structresSelected' | translate }}
                      </div>
                      <div *ngIf="item.subDoc ==='gestAmmTivoDipendenti'">
                        {{ 'properties.addDocumentsPage.employees' | translate }}
                      </div>
                      <div class="pl-2" *ngFor="let structure of item.structureSelected">
                        <div class="text-wrapper">
                          <mat-checkbox [(ngModel)]="structure.value" (change)="onChangePlant()"
                            class="checkbox-insert" [disabled]="docUploaded">
                            {{ structure.name }}
                          </mat-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-7">
              <h5>{{ 'properties.addDocumentsPage.fieldsData' | translate }}</h5>
              <form [formGroup]="form">
                <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
              </form>
              <div class="row w-100">
                <div class="col-12">
                  <div class="alert alert-warning my-3" role="alert" *ngIf="!canSubmitForm">
                    {{ 'properties.addDocumentsPage.selectAtLeastOne' | translate }}
                    {{ 'properties.addDocumentsPage.element' | translate }}
                  </div>
                  <mat-spinner-button (btnClick)="onFormSubmit()" role="submit" [options]="formBtnOptions"
                    class="btn-elevate" *ngIf="canSubmitForm && !docUploaded">
                  </mat-spinner-button>
                </div> <!-- /.col -->
              </div> <!-- /.row -->
            </div>
          </div>
          <!-- /STEP 1: input data of selected docs -->

        </ng-container>
        <!-- /Select docs from list and input data -->


      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->